import React from "react";
import {
  Flex,
  Text,
  Button,
  Card,
  Heading,
  Box,
  Container,
  Grid,
  Badge,
  Avatar,
  Separator,
} from "@radix-ui/themes";

const RadixExample = () => {
  return (
    <Container size="3" p="6">
      <Flex direction="column" gap="6">
        <Box>
          <Heading size="8" mb="4">
            Welcome to Radix UI Integration
          </Heading>
          <Text size="3" color="gray">
            This is an example of how to use Radix UI components in your Lucy
            project.
          </Text>
        </Box>

        <Separator size="4" />

        <Grid columns="2" gap="4">
          <Card size="2">
            <Flex direction="column" gap="3">
              <Flex align="center" gap="3">
                <Avatar
                  size="3"
                  src="https://images.unsplash.com/photo-1607346256330-dee7af15f7c5?&w=64&h=64&dpr=2&q=70&crop=focalpoint&fp-x=0.67&fp-y=0.5&fp-z=1.4&fit=crop"
                  fallback="A"
                />
                <Box>
                  <Text as="div" size="2" weight="bold">
                    Andrew Ainsley
                  </Text>
                  <Text as="div" size="2" color="gray">
                    andrew.ainsley@email.com
                  </Text>
                </Box>
              </Flex>
              <Separator size="2" />
              <Text size="2">
                Senior Software Engineer with 8+ years of experience in React
                and Node.js.
              </Text>
              <Flex gap="2">
                <Badge color="blue">React</Badge>
                <Badge color="green">Node.js</Badge>
                <Badge color="purple">TypeScript</Badge>
              </Flex>
            </Flex>
          </Card>

          <Card size="2">
            <Flex direction="column" gap="3">
              <Heading size="3">Quick Actions</Heading>
              <Flex direction="column" gap="2">
                <Button variant="solid" color="blue">
                  Create Interview
                </Button>
                <Button variant="outline">View Reports</Button>
                <Button variant="soft" color="green">
                  Start Mock Test
                </Button>
              </Flex>
            </Flex>
          </Card>
        </Grid>

        <Card size="2">
          <Flex direction="column" gap="4">
            <Heading size="4">Available Radix UI Components</Heading>
            <Grid columns="3" gap="3">
              <Box
                p="3"
                style={{
                  border: "1px solid var(--gray-6)",
                  borderRadius: "var(--radius-3)",
                }}
              >
                <Text weight="bold">Layout</Text>
                <Text size="2" color="gray">
                  Box, Flex, Grid, Container
                </Text>
              </Box>
              <Box
                p="3"
                style={{
                  border: "1px solid var(--gray-6)",
                  borderRadius: "var(--radius-3)",
                }}
              >
                <Text weight="bold">Typography</Text>
                <Text size="2" color="gray">
                  Text, Heading, Blockquote
                </Text>
              </Box>
              <Box
                p="3"
                style={{
                  border: "1px solid var(--gray-6)",
                  borderRadius: "var(--radius-3)",
                }}
              >
                <Text weight="bold">Interactive</Text>
                <Text size="2" color="gray">
                  Button, Link, Card
                </Text>
              </Box>
            </Grid>
          </Flex>
        </Card>
      </Flex>
    </Container>
  );
};

export default RadixExample;
